import { render, staticRenderFns } from "./RefreshNotice.vue?vue&type=template&id=5c4ca818&"
import script from "./RefreshNotice.vue?vue&type=script&lang=js&"
export * from "./RefreshNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports